export const TPDI_AWS_EU_CENTRAL_1 = 'sh.tpdi.byoc.eu-central-1';
export const TPDI_AWS_US_WEST_2 = 'sh-tpdi-byoc-us-west-2';
export const TPDI_GCP_US_CENTRAL_1 = 'sh-tpdi-byoc-uscentral1';
export const AWS_EU_CENTRAL_1 = 'aws-eu-central-1';
export const AWS_US_WEST_2 = 'aws-us-west-2';
export const SGS_HQ = 'sgs-hq';
export const GCP_US_CENTRAL_1 = 'gcp-us-central1';

export enum CollectionOwner {
  USER = 'Me',
  SHARED = 'Shared with me',
  SANDBOX = 'Sandbox',
}

export enum ByocLayerSubtype {
  BYOC = 'BYOC',
  PLANET = 'PLANET',
  ZARR = 'ZARR',
}

export enum SampleFormat {
  UINT = 'UINT',
  INT = 'INT',
  FLOAT = 'FLOAT',
}

const ALL_LOCATIONS_CONFIG: {[s: string]: string | undefined} = {
  [AWS_EU_CENTRAL_1]: 'https://services.sentinel-hub.com',
  [AWS_US_WEST_2]: 'https://services-uswest2.sentinel-hub.com',
  [SGS_HQ]: '',
  [GCP_US_CENTRAL_1]: 'https://services-gcp.sentinel-hub.com',
};

export const LOCATION_NAMES: {[s: string]: string} = {
  [AWS_EU_CENTRAL_1]: 'AWS EU (Frankfurt)',
  [AWS_US_WEST_2]: 'AWS US West (Oregon)',
  [SGS_HQ]: 'Sinergise Test / AWS EU (Frankfurt)',
  [GCP_US_CENTRAL_1]: 'GCP US Central',
};

export function locationToBaseUrl(location: string): string | undefined;
export function locationToBaseUrl(
  config: Record<string, string | undefined>,
): Record<string, string>;
export function locationToBaseUrl(
  arg: string | Record<string, string | undefined>,
): string | undefined | Record<string, string> {
  if (typeof arg === 'string') {
    return ALL_LOCATIONS_CONFIG[arg];
  }
  return Object.fromEntries(
    Object.entries(arg).filter(([, v]) => v !== undefined),
  ) as Record<string, string>;
}

export const PLANET_BUCKETS = [
  'planet.com',
  'sh.subscriptions.byoc.eu-central-1',
  'pip-subscriptions-byoc-us-central1-prod',
  'sh-staging0-eu-central-1-byoc-subscriptions',
];

export const PLANET_BAND_WARNING_BUCKETS = [
  'sh.tpdi.byoc.eu-central-1',
  'sh.subscriptions.byoc.eu-central-1.stage',
  'sh.subscriptions.byoc.eu-central-1',
];

export enum SelectedDataCollectionTab {
  'DETAILS' = 'DETAILS',
  'TILES' = 'TILES',
  'ARRAYS' = 'ARRAYS',
  'CONFIGURATIONS' = 'CONFIGURATIONS',
}
